<template>
  <div style="width: 1200px;margin:0 auto;">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      text-color="#fff"
      active-text-color="#52a665"
    >
      <!-- <el-menu-item> -->
        <div @click="toEvents()" style="margin-top: 12px;display:inline-block;cursor:pointer;">
          <img v-if="whihe" src="/official/static/img/ppwc/logo_02.png" />
          <img v-else src="/official/static/img/ppwc/logo_01.png" />
        </div>
      <!-- </el-menu-item> -->
      <!-- <el-menu-item>
        <a
          href="http://www.gaminglabs.com/extranetgli/cmsadmin/getsplash.asp?i=277"
          target="_blank"
        >
          <img style="width: 64px;" src="/official/static/img/home/caming.png" />
        </a>
      </el-menu-item> -->

      <!-- <el-menu-item class="el-menu-item-margin" style="width: 150px;text-align:center;padding: 0px;" index="/home">
        <a @click="toHome()">{{ $t('common.p2') }}</a>
      </el-menu-item>

      <el-popover placement="top" trigger="hover"  width="1200" :visible-arrow="false" id="el-popover-menu">
        <div class="container">
          <div class="popular-content" :style="popoverStyle">
            <div style="display:inline-block;width:150px;">
              <a style="cursor: pointer;" @click="toEvents">{{ $t('common.p4') }}</a>
              <a style="cursor: pointer;" @click="toFestival">{{ $t('common.p5') }}</a>
            </div>
            <div style="display:inline-block;width:150px;">
              <a v-for="item in tabs" :key="item.id" @click="toBlog(item.id)">{{ item.name }}</a>
            </div>
        </div>
        </div>
        <div style="display: inline-block;" slot="reference">
            <el-menu-item index="/events" style="width: 150px;text-align:center;padding: 0px;">
              <a style="color:inherit;" @click="toEvents()">{{ $t('common.p3') }}</a>
            </el-menu-item>
            <el-menu-item index="/blog" style="width: 150px;text-align:center;padding: 0px;">
              <a style="color:inherit;" @click="toBlogHome()">{{ $t('common.p6') }}</a>
            </el-menu-item>
        </div>
      </el-popover>

      <el-menu-item class="contact-us">
        <a target="_blank" href="#/about">{{ $t('common.p21') }}</a>
      </el-menu-item> -->
      <li class="lang">
        <lang-select></lang-select>
      </li>
    </el-menu>
  </div>
</template>

<script>
// @ is an alias to /src
import LangSelect from './LangSelect.vue'
import { getBlogTab } from '@/api/official'

export default {
  data () {
    return {
      popover: false,
      popoverStyle: {

      },
      tabs: []
    }
  },
  props: ['whihe'],
  components: {
    LangSelect
  },
  computed: {
    activeIndex () {
      return this.$store.state.tab
    }
  },
  methods: {
    initData () {
      getBlogTab()
        .then(res => {
          this.tabs = res.data.list.map(v => {
            // this.initBlogList(v.id)
            return { name: v.lang[this.$store.getters.language], id: v.id + '' }
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    toHome () {
      this.$router.push({ name: 'home', query: { t: Date.now() } })
    },
    toBlogHome () {
      this.$router.push({ name: 'blog', query: { t: Date.now() } })
    },
    toBlog (id) {
      this.$router.push({ name: 'blog', query: { tab: id, t: Date.now() } })
    },
    toFaq (id) {
      this.$router.push({ name: 'faq', query: { index: id, t: Date.now() } })
    },
    toEvents () {
      this.$router.push({ name: 'events', query: { t: Date.now() } })
    },
    toFestival () {
      this.$router.push({ name: 'festival', query: { t: Date.now() } })
    }
  },
  created () {
    // this.initData()
  },
  mounted () {
    // setTimeout(() => {
    //   console.log(document.querySelector('#el-popover-menu').offsetLeft)
    //   this.popoverStyle = {
    //     left: '361px' // document.querySelector('#el-popover-menu').offsetLeft - 10 + 'px'
    //   }
    // }, 10)
  }
}
</script>

<style lang="scss">
.el-popover.el-popper {
  background: rgba(0, 0, 0, 0.6);
  border: none;
  margin-top: 3px!important;
  padding: 0px;
  width: 100%!important;
  min-width: 1200px!important;
  left: 0px!important;
  .popular-content {
    position: relative;
    width: 600px;
    top: 0px;
    left:20px;
    // text-align: center;
    font-size: 14px;
    padding: 10px 0px 16px 0px;
    div {
      vertical-align: top;
      text-align: center;
    }
    a {
      color: #fff;
      display: block;
      line-height: 32px;
      cursor: pointer;
      &:hover {
        color: #52a665;
      }
    }
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-menu-demo {
  position: relative;
  background-color: rgba(0, 0, 0, 0);
  a {
    cursor: pointer;
  }
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
  .el-menu-item {
    height: 57px;
    line-height: 57px;
    font-size: 18px;
    color: #d2d2d2;
    padding: 0 10px;
    border-bottom: none;
    display: inline-block;
    a {
      display: block;
    }
    &:hover {
      a {
        color: #52a665!important;
      }
    }
  }
  .el-menu-item-margin {
    padding: 0 35px;
  }
  .contact-us {
    float: right;
    font-size: 14px;
    padding: 0 10px;
  }
  .el-dropdown-link {
    cursor: pointer;
    font-size: 14px;
    color: #d2d2d2;
  }
  .lang {
    float: right;
    height: 58px;
    line-height: 60px;
    padding: 0 10px;
    cursor: pointer;
    list-style: none;
    border-bottom: 2px solid transparent;
    &:focus {
      outline: none;
    }
  }
}
</style>
